import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.styl']
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/app.component.ts